/*
++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
Este componente sera utilizado como um DataFile,
obtendo as informacoes necessarias para criar os Cards de Eventos
E os dados serao enviados para o AllCards.js
++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
*/
import "./CardStyles.css";
import React, { Component } from "react";
import BuildCards from '../components/BuildCards';

const api_lista_shows = "https://api2.gustech.tec.br/ticketApp/api/lista_shows";

/*Criando classe*/
 class GetCardShows extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lista_shows: []
        };
    }
    
    componentDidMount() {
        fetch(api_lista_shows, {  
            method: 'GET',  
            mode: 'cors',     
          })
        .then(response => response.json())
        .then(result => {
            console.log(result)
            this.setState({ lista_shows: result})
        });
    }
    
    render = () => <BuildCards data={this.state.lista_shows}/>

}

export default GetCardShows